const environmentEnum = {
    UAT: 'UAT',
    STG: 'STG',
    LIVE: 'LIVE',
    LOCALDEV: 'LOCALDEV',
    DEV: 'DEV',
    PAT: 'PAT',
}

export const environmentOptions = [
    { value: environmentEnum.UAT, label: environmentEnum.UAT },
    { value: environmentEnum.STG, label: environmentEnum.STG },
    { value: environmentEnum.LIVE, label: environmentEnum.LIVE },
];

export default environmentEnum;